import { Component, OnInit, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { PaginationViewModel } from 'src/app/viewModels/permissions/paginationViewModel/pagination-view-model';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { DeletePermissionViewModel } from 'src/app/viewModels/permissions/deletePermissionViewModel/delete-permission-view-model';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { clickableColumns } from 'src/app/middleware/common/clickableColumns';
import { ExcelServicesService } from 'src/app/middleware/common/excel-services.service';
import { downloadableListAsDisplayedColumns } from 'src/app/middleware/common/table/table.component';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { CommonService } from 'src/app/middleware/common/common.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { PermissionService } from '../services/permission/permission.service';
import * as jwt_decode from 'jwt-decode';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';

@Component({
  selector: 'app-permission-list',
  templateUrl: './permission-list.component.html',
  styleUrls: ['./permission-list.component.scss']
})
export class PermissionListComponent implements OnInit ,AfterViewInit{
 
  totalCount: number;  

  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    SearchKey:"",
    userID:"",
    organizationID:0,
    OfficeIDList:[]
  };
  pageIndex: any;
  pageSize: any;
  value = '';
  paginatorTotalLength: any;
  currentData: PageEvent;
  SearchValueForPermissionSubscription: Subscription;
  Module:string;
  currentUser: any;
  databaseId: string;
  organizationId: string;
  OfficeIDList: any=[];

  constructor(private permissionService: PermissionService, private paginationVM: PaginationViewModel,
    private loaderService: LoaderService, private toastr: ToastrService,
    private statusConst: StatusConstant, private dialog: MatDialog,
    private deleteVM: DeletePermissionViewModel, private router: Router,
    private excelService: ExcelServicesService, private constant: Constants,
    private commonService: CommonService, private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private _dataSharingService: DataSharingService) {
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      });
     const encryptedtoken = sessionStorage.getItem('userToken');
     this.databaseId = sessionStorage.getItem('databaseId');
     this.organizationId = sessionStorage.getItem('organizationID');
     const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
     this.currentUser = jwt_decode(token);

    //this.permissions = JSON.parse(sessionStorage.getItem("permissions"));
    // this.permissions.forEach(element=>{
    //   this.constant.routeArray.forEach(route => {
    //     if (element.moduleRoute == route.permissionRoute) {
    //   if (element.isAddPermission == true) {
    //     this.showAdd = true;
    //   }
    //    if (element.isDeletePermission == true) {
    //     this.showDelete = true;
    //   }
    //    if (element.isEditPermission == true) {
    //     this.showEdit = true;
    //   }
    // }
       
    //   });
    // })
  
       if (this.showEdit == true && this.showDelete == true) {
        this.sendDisplayedColumns = ['permissionName', 'description', 'moduleName', 'createdOnDt', 'addPermission', 'editPermission', 'deletePermission', 'Edit', 'Delete']; 
        this.showColumnNames = ['Permission Name', 'Permission Description', 'Module Name', 'Created On', 'Add Permission', 'Edit Permission', 'Delete Permission', 'Edit', 'Delete'];
        this.clickableColumns = [{ column: 'Edit', icon: 'edit', function: 'openEditDialog' }, {
          column: 'Delete', icon: 'delete', function: 'deleteUserDialog'
        }];
      }
      else if (this.showEdit == true  && this.showDelete == false) {
        this.sendDisplayedColumns = ['permissionName', 'description', 'moduleName', 'createdOnDt', 'addPermission', 'editPermission', 'deletePermission', 'Edit'];  // this is being used in child component $$...		
        this.showColumnNames = ['Permission Name', 'Permission Description', 'Module Name', 'Created On', 'Add Permission', 'Edit Permission', 'Delete Permission', 'Edit'];  // this is being used if child component will show lable with different names $$...		
        this.clickableColumns = [{ column: 'Edit', icon: 'edit', function: 'openEditDialog' }];
      }
      else if(this.showEdit == false  && this.showDelete == true){
        this.sendDisplayedColumns = ['permissionName', 'description', 'moduleName', 'createdOnDt', 'addPermission', 'editPermission', 'deletePermission', 'Delete'];
        this.showColumnNames = ['Permission Name', 'Permission Description', 'Module Name', 'Created On', 'Add Permission', 'Edit Permission', 'Delete Permission', 'Delete']; 
        this.clickableColumns = [{ column: 'Delete', icon: 'delete', function: 'deleteUserDialog' }];
      }
      else{
        this.sendDisplayedColumns = ['permissionName', 'description', 'moduleName', 'createdOnDt', 'addPermission', 'editPermission', 'deletePermission'];  // this is being used in child component $$...		
        this.showColumnNames = ['Permission Name', 'Permission Description', 'Module Name', 'Created On', 'Add Permission', 'Edit Permission', 'Delete Permission'];  // this is being used if child component will show lable with different names $$...		
        this.clickableColumns = [];
      }
     }

  ngOnDestroy(): void {
      this.SearchValueForPermissionSubscription.unsubscribe();    
   }

  ngOnInit(): void {
    this.Module="Permission";  
    this.SearchValueForPermissionSubscription = this._dataSharingService.getSearchValueForPermission().subscribe((result) => {
      this.Search(result);   
    });  
  }


  ngAfterViewInit(){
    setTimeout(() => {
      this.getAllPermissions(this.pageModelData);
    }, 1);
  }


  dataSource;
  displayedColumns = ['PermissionName', 'PermissionDescription', 'CreatedOn','buttons'];
  permissionResponseHolder: any;
  permissionList: any[] = [];
  deletePermissionId: any;
  deletePermissionResponseHolder: any;
  isEdit = false;
  //currentData: any;
  showEdit: boolean = true;
  showAdd: boolean = true;
  showDelete: boolean = true;

  targetList: any = [];
  sendDisplayedColumns: string[] = [];
  showColumnNames: string[] = [];
  clickableColumns: clickableColumns[] = [];
  permissions: any[] = [];
  showcreateForm: Boolean =false;
  showSidePanel: boolean = false;
  showeditForm: boolean = false;
  
  
  getAllPermissions(pageData: any){
     this.loaderService.show();    
     this.pageModelData.pageIndex = pageData.pageIndex;
     this.pageModelData.pageSize = pageData.pageSize;
     this.pageModelData.SearchKey = pageData.SearchKey.trim();
     this.pageModelData.userID= this.currentUser.UID;
     this.pageModelData.organizationID=Number(this.organizationId);
     this.pageModelData.OfficeIDList=this.OfficeIDList; 
     this.pageIndex = pageData.pageIndex;
     this.pageSize = pageData.pageSize;
     this.permissionService.getAllPermissions(this.pageModelData).subscribe(response=>{
      if (response != undefined) {
        this.loaderService.hide();  
        this.permissionResponseHolder = response;
        this.permissionList = this.permissionResponseHolder.data.permissionsModel;
        this.totalCount =  this.permissionResponseHolder.data.totalCount;//this.permissionList[0].totalCount;
        this.pageModelData.pageIndex = this.permissionResponseHolder.data.pageIndex;
        this.pageIndex = this.permissionResponseHolder.data.pageIndex;
        this.pageSize = pageData.pageSize;
        this.loaderService.hide();        
      }  
      else{
        this.loaderService.hide();
      }    
    });
  }

  openEditDialogData(values){
    let userData = values.data;
    if (values.function == "openEditDialog") {
      this.openEditDialog(true, userData);
    }else{
        this.deleteUserDialog(values.data);
       }    
  }

  closeSidePanel(event){
    this.showSidePanel = false;    
    this.showeditForm = false;
    if(event == true){
      this.getAllPermissions(this.pageModelData);
    }
    this.showcreateForm = false;
  }


  openEditDialog(editable: boolean, permission: any) {
    this.isEdit = editable;    
    let dataarr = [];
    dataarr.push(this.isEdit);
    dataarr.push(permission);
    this.commonService.setEditData(dataarr);
    this.showcreateForm = false;
    this.showeditForm = true;
    this.showSidePanel = true;    
  }

  exportAsXLSX(): void {
    this.pageModelData.pageIndex = 0;
    let pagesize = this.pageModelData.pageSize;
    this.pageModelData.pageSize = this.totalCount;
    // this.service.getSubDataSourceDetails(this.paramObj).subscribe((res: any) => {
    //   if (res.hasOwnProperty('subDataSourceList')) {
    //     if (res.subDataSourceList.length > 0) {
         
          // let exportList: any[] = downloadableListAsDisplayedColumns(res.subDataSourceList, this.sendDisplayedColumns, this.clickableColumns, this.showColumnNames);
          // this.excelService.exportAsExcelFile(exportList, 'ManageSubDataSourceList');
    //     }
    //   }
    // });
    this.paginationVM.pageIndex = this.pageModelData.pageIndex;
    this.paginationVM.pageSize = this.pageModelData.pageSize;
    this.loaderService.show();  
    this.permissionService.getAllPermissions(this.paginationVM).subscribe(response=>{
      if (response != undefined) {
        this.loaderService.hide();
        this.permissionResponseHolder = response;
        let _permissionList = this.permissionResponseHolder.data.permissionsModel;
        let exportList: any[] = downloadableListAsDisplayedColumns(_permissionList, this.sendDisplayedColumns, this.clickableColumns, this.showColumnNames);
        this.excelService.exportAsExcelFile(exportList, 'PermissionList');
      }      
    });    
    this.pageModelData.pageSize =pagesize;
  }

  // open dialog box for deleting selected user
  deleteUserDialog(data): void {
    const message = `Are you sure you want to delete this permission?`;   
    this.deleteVM.permissionID = data.permissionID;
    this.deleteVM.deletedBy = this.currentUser.UID;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });

    dialogRef.beforeClosed().subscribe(async dialogResult => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          const result = await this.permissionService.deletePermission(this.deleteVM).toPromise();
          this.deletePermissionResponseHolder = result;
          this.loaderService.hide();
          this.toastr.success("Permission deleted successfully.", '', {
            timeOut: 3000,
          });
          let count = (Number(this.paginationVM.pageIndex) * Number(this.paginationVM.pageSize))
          if(this.totalCount - 1 == count){
            this.paginationVM.pageIndex =this.paginationVM.pageIndex - 1;
          }
          this.getAllPermissions(this.pageModelData);
          return result;

        } else {
          this.toastr.error(this.deletePermissionResponseHolder.message, '', {
            timeOut: 3000,
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }
 

  CallNextPrevPageData(pageData) {
    // this.currentData = pageData;
    // this.pageModelData.pageIndex = pageData.pageIndex;
    // this.pageModelData.pageSize = pageData.pageSize;
    // this.paginationVM.pageIndex = pageData.pageIndex;
    // this.paginationVM.pageSize = pageData.pageSize;
    this.currentData = pageData;
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.SearchKey = this.value.trim();
    this.getAllPermissions(this.pageModelData);
  }

  Search(filterValue) {
    this.pageModelData.SearchKey = filterValue.trim();
    this.pageModelData.pageIndex = 0;
    this.pageModelData.pageSize = 10;
    this.getAllPermissions(this.pageModelData);
  }


  addPermissions(){   
    this.showcreateForm = true;
    this.showSidePanel = true;
    this.showeditForm = false;
  }

}
